import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import quizCalloutImage from '../../../../../images/components/experienceCalloutImages/architect-standing-at-a-desk-with-blueprints.webp';
// styles
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    moduleName='quiz-callout-module'
    sectionId='quiz-callout-disability-insurance'
    assistiveText='Get started with our Disability Insurance quiz'
    buttonText='Take the quiz'
    calloutBackgroundVariant='lightC'
    withBGImage
    withHoverShadow
    headingText={<>How much do you know about <WidowBlock>disability insurance&#63;</WidowBlock></>}
    isFullWidth
    imageUrl={quizCalloutImage.toString()}
    linkUrl='/life-and-money/quiz/quiz-how-much-do-you-know-about-disability-insurance/'
    disableLazyLoad
  />
);
